export const IMAGE_GALLERY_STYLES = {
  root: "w-full",
  title: "text-[20px] md:text-[24px] font-bold text-ticketon-dark-text",
  description: "mt-2 text-[13px] text-ticketon-gray-600",
  gridBase: "mt-4 grid grid-cols-1 gap-3 sm:gap-4",
  gridCols2: "sm:grid-cols-2",
  gridCols3: "sm:grid-cols-2 lg:grid-cols-3",
  gridCols4: "sm:grid-cols-2 lg:grid-cols-4",
  item: "group relative overflow-hidden rounded-[12px] bg-ticketon-gray-bg",
  imageWrapper: "relative aspect-[4/3] w-full",
  image:
    "h-full w-full object-cover transition-transform duration-300 group-hover:scale-105",
  caption:
    "absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 text-[12px] font-medium text-white",
} as const;

export const COLUMNS_CLASS_MAP: Record<
  2 | 3 | 4,
  keyof typeof IMAGE_GALLERY_STYLES
> = {
  2: "gridCols2",
  3: "gridCols3",
  4: "gridCols4",
};
